var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"headers":_vm.header,"title-text":"消息发送配置列表","get-data-func":_vm.getSendConfigList}}),_c('l-fixed-btn',{attrs:{"icon":"$vuetify.icons.add"},on:{"click":_vm.addSendConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }